module.exports = __webpack_public_path__ + "img/enfoques.e44165e8.png";